const Emitter = require('utils/event-emitter');

var service = {

	AJAX_EVENT: 'ajax-event',

	running: false,

	emitter: new Emitter(),

	setRunning(running){
		service.running = running;
		service.emitter.emit(service.AJAX_EVENT);
	},

	mixin: {
		componentDidMount() {
			service.emitter.addEventListener(service.AJAX_EVENT,this.refreshAjaxStatus);
		},

		componentWillUnmount(){
			service.emitter.removeEventListener(service.AJAX_EVENT,this.refreshAjaxStatus);
		},

		refreshAjaxStatus(){
			this.setState({});
		},

		isAjaxRunning(){
			return service.running;
		},

		setAjaxRunning(running){
			service.setRunning(running);
		}
	}

};

module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/utils/ajax-indicator.js
 **/